export default {
  identifyingCode: {
    timer: null,
    time: 60
  },
  popup: []
}



// WEBPACK FOOTER //
// ./src/logic/common/state.js